import template from './channel-links.hbs';
import Keyboard from '../lib/keyboard.es6';
import style    from 'channel-links.scss';

const NEXT = 'next';
const PREV = 'prev';

export default Backbone.View.extend({

    template,

    tagName: 'div',

    className: 'channelLinks',

    events: {
        'mouseover .channelLinks__item': onMouseOver
    },

    initialize (props) {
        this.actions = {
            select: props.select,
        };
        this.mouseEventsEnabled = true;
        this.setInitialState(props);
        this.render(this.state);
        this.onKeyDown = onKeyDown.bind(this);
    },

    setup () {
        toggleEventHandlers.call(this, 'on');
    },

    teardown () {
        toggleEventHandlers.call(this, 'off');
    },

    setInitialState (props) {
        this.state = props.state;
    },

    setState (state) {
        this.state = state;
        this.render(this.state);
    },

    render (state = {}) {
        this.$el.html(this.template(this.getTemplateData(state)));
        this.$links = this.$('.channelLinks__link');
        this.$liveRegion = this.$('.channelLinks__live-region');
        if (this.hasSelection()) {
            this.highlight(this.state.current);
        }
        return this;
    },

    getTemplateData (state) {
        return state;
    },

    select (direction) {
        let items = this.state.filtered;
        let current = this.state.current;

        if (!items.length) {
            return;
        }

        current = getNextIndex(direction, items.length, current);
        // boolean argument specifies element alignment relative to the the 
        // scrollable ancestor: true = top, false = bottom
        this.$links[current].scrollIntoView(false);
        this._select(current);
    },

    _select (current) {
        this.state.current = current;
        this.highlight(current);
    },

    getSelection () {
        if (!this.state || !this.state.filtered.length) {
            return false;
        }
        return this.state.filtered[this.state.current];
    },

    hasSelection () {
        return Boolean(this.getSelection());
    },

    _setLiveRegionTimeout: null,
    setLiveRegion (current) {
        if (this._setLiveRegionTimeout) {
            clearTimeout(this._setLiveRegionTimeout);
            this._setLiveRegionTimeout = null;
        }
        var item = this.state.filtered[current];
        this._setLiveRegionTimeout = setTimeout(_.bind(function () {
            this.$liveRegion.text(item.displayName + ', ' + item.type + ' on ' + item.serverName);
        }, this), 1000);
    },

    highlight (current) {
        this.$links.removeClass('selected');
        $(this.$links[current]).addClass('selected');
        this.setLiveRegion(current);
    }
});


function toggleEventHandlers (fn) {
    $(window)[fn]('keydown', this.onKeyDown);
}

function toggleMouseEvents (bool) {
    this.mouseEventsEnabled = bool;
}

function onMouseOver (e) {
    if (!this.mouseEventsEnabled) {
        return;
    }
    let index = $(e.currentTarget).index();
    this._select(index);
}

function onKeyDown (e) {
    let up       = e.which === Keyboard.KEYS.UP;
    let down     = e.which === Keyboard.KEYS.DOWN;
    let tab      = e.which === Keyboard.KEYS.TAB;
    let shiftTab = tab && e.shiftKey;
    let enter = e.which === Keyboard.KEYS.ENTER;

    if (up || down || tab || shiftTab || enter) {
        e.preventDefault();
        if (this.mouseEventsEnabled) {
            toggleMouseEvents.call(this, false);
            $(window).one('mousemove', toggleMouseEvents.bind(this, true));
        }
    } else {
        return;
    }

    if (up || shiftTab) {
        this.select(PREV);
    }
    if (down || (!shiftTab && tab)) {
        this.select(NEXT);
    }
    
    if (enter && this.hasSelection()) {
        var selection = this.getSelection();
        this.actions.select(selection);
    }
}

function getNextIndex (direction, length, current) {
    if (direction === PREV) {
        if (current === 0) {
            current = length - 1;
        } else {
            current--;
        }
    }

    if (direction === NEXT) {
        if (current === length - 1) {
            current = 0;
        } else {
            current++;
        }
    }
    
    return current;
}



// WEBPACK FOOTER //
// ./app/src/view/channel-links.es6